// @flow
import React, { Component } from 'react';
import ProductCardList from 'components/common/ProductCardList/ProductCardList';
import type { State } from 'store';
import { DisplayActions } from 'store/actionCreators';
import type { ProductItem } from 'store/modules/display';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';
import { track, TRACKING_EVENTS } from 'lib/tracking';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  products: ?(ProductItem[]),
  prefetched: ?(ProductItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class RecentProductCards extends Component<Props> {
  prevCursor: ?string = null;
  trackedListId: ?string = null;

  prefetch = async () => {
    const { products, prefetching, loading, category, sort } = this.props;
    if (!products || products.length === 0 || prefetching || loading) return;
    const lastId = products[products.length - 1].id;
    if (this.props.prefetched) {
      DisplayActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await DisplayActions.prefetchRecentProducts(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { products, shouldCancel, category, sort } = this.props;
    try {
      if (products && products.length > 0) {
        // do not fetch product data when already exists
        return;
      }
      if (!shouldCancel) {
        await DisplayActions.getRecentProducts('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await DisplayActions.getRecentProducts('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  trackProductListViewed = () => {
    const { products, category } = this.props;
    const listId = category ? `display:${category}` : 'recent';
    const listName = category || '최신 상품';
    if (!products || products.length === 0) return;
    if (this.trackedListId === listId) return;

    const items = products.slice(0, 20).map(product => ({
      productId: product.id,
      productTitle: product.title,
    }));
    track(TRACKING_EVENTS.PRODUCT_LIST_VIEWED, {
      listId,
      listName,
      items,
    });
    this.trackedListId = listId;
  };

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    this.trackProductListViewed();
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    const { category } = this.props;
    const listId = category ? `display:${category}` : 'recent';
    const listName = category || '최신 상품';

    return (
      <ProductCardList
        products={this.props.products}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
        isTrending={false}
        listId={listId}
        listName={listName}
      />
    );
  }
}

const mapStateToProps = ({ display, pender, base, common }: State) => ({
  products: display.recent.products,
  prefetched: display.recent.prefetched,
  prefetching: pender.pending['display/PREFETCH'],
  loading: pender.pending['display/GET_RECENT_POSTS'],
  width: base.windowWidth,
  hasEnded: display.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(RecentProductCards);



// WEBPACK FOOTER //
// ./src/containers/list/DisplayProductCards.js